module.exports = __webpack_public_path__ + "img/value_icon_two.0c64c9b7.png";